import { z } from 'zod'
import { ErrorCode } from '~/types/error'

export const grantUserPointsSchema = z.object({
  amount: z.coerce
    .number()
    .int({ message: ErrorCode.REQUIRED })
    .min(1, { message: ErrorCode.REQUIRED })
    .max(1000000, { message: ErrorCode.TOO_LONG }),
  reason: z.string().trim().max(255, { message: ErrorCode.TOO_LONG }).optional().or(z.literal('')),
})

export type GrantUserPointsFormData = z.infer<typeof grantUserPointsSchema>
